export const PAYOUT_FEES_GRID_NAME = 'PayoutFeesGrid';
export const PAYOUT_REQUESTS_GRID_NAME = 'PayoutRequestsGrid';

export const PAYOUT_METHOD__WIRE = 'WIRE';
export const PAYOUT_METHOD__CREDIT_CARD = 'CREDITCARD';
export const PAYOUT_METHOD__EPASSPORTE = 'EPASSPORTE';
export const PAYOUT_METHOD__WC_CHECK = 'WC_CHECK';
export const PAYOUT_METHOD__WC_WIRE = 'WC_WIRE';
export const PAYOUT_METHOD__PAYONEER = 'PAYONEER';
export const PAYOUT_METHOD__XCARD = 'XCARD';

const payoutMethods = [
  PAYOUT_METHOD__WIRE,
  PAYOUT_METHOD__CREDIT_CARD,
  PAYOUT_METHOD__EPASSPORTE,
  PAYOUT_METHOD__WC_CHECK,
  PAYOUT_METHOD__WC_WIRE,
  PAYOUT_METHOD__PAYONEER,
  PAYOUT_METHOD__XCARD,
];

const payoutMethodLangKeys = {
  [PAYOUT_METHOD__WIRE]: 'payout.method.wire',
  [PAYOUT_METHOD__CREDIT_CARD]: 'payout.method.credit-card',
  [PAYOUT_METHOD__EPASSPORTE]: 'payout.method.epasporte',
  [PAYOUT_METHOD__WC_CHECK]: 'payout.method.wc-check',
  [PAYOUT_METHOD__WC_WIRE]: 'payout.method.wc-wire',
  [PAYOUT_METHOD__PAYONEER]: 'payout.method.payoneer',
  [PAYOUT_METHOD__XCARD]: 'payout.method.xcard',
};

const PAYOUT_STATUS__PENDING = 'PENDING';
const PAYOUT_STATUS__APPROVED = 'APPROVED';
const PAYOUT_STATUS__CANCELED = 'CANCELED';
const PAYOUT_STATUS__CANCELED_BY_USER = 'CANCELED_BY_USER';

const payoutStatuses = [
  PAYOUT_STATUS__PENDING,
  PAYOUT_STATUS__APPROVED,
  PAYOUT_STATUS__CANCELED,
  PAYOUT_STATUS__CANCELED_BY_USER,
];

const payoutStatusLangKeys = {
  [PAYOUT_STATUS__PENDING]: 'payout.status.pending',
  [PAYOUT_STATUS__APPROVED]: 'payout.status.approved',
  [PAYOUT_STATUS__CANCELED]: 'payout.status.canceled',
  [PAYOUT_STATUS__CANCELED_BY_USER]: 'payout.status.canceled-by-user',
};

const PAYOUT_CANCEL_REASON__BENEFICIARY_INVALID = 'BENEFICIARY_INVALID';
const PAYOUT_CANCEL_REASON__IBAN_INCORRECT = 'IBAN_INCORRECT';
const PAYOUT_CANCEL_REASON__SWIFT_INCORRECT = 'SWIFT_INCORRECT';
const PAYOUT_CANCEL_REASON__BANK_INCORRECT = 'BANK_INCORRECT';
export const PAYOUT_CANCEL_REASON__OTHER = 'OTHER';

const payoutCancelReasons = [
  PAYOUT_CANCEL_REASON__BENEFICIARY_INVALID,
  PAYOUT_CANCEL_REASON__IBAN_INCORRECT,
  PAYOUT_CANCEL_REASON__SWIFT_INCORRECT,
  PAYOUT_CANCEL_REASON__BANK_INCORRECT,
  PAYOUT_CANCEL_REASON__OTHER,
];

const payoutCancelReasonLangKeys = {
  [PAYOUT_CANCEL_REASON__BENEFICIARY_INVALID]: 'payout.cancel-reason.beneficiary-invalid',
  [PAYOUT_CANCEL_REASON__IBAN_INCORRECT]: 'payout.cancel-reason.iban-incorrect',
  [PAYOUT_CANCEL_REASON__SWIFT_INCORRECT]: 'payout.cancel-reason.swift-incorrect',
  [PAYOUT_CANCEL_REASON__BANK_INCORRECT]: 'payout.cancel-reason.bank-incorrect',
  [PAYOUT_CANCEL_REASON__OTHER]: 'payout.cancel-reason.other',
};

export {
  payoutMethods,
  payoutMethodLangKeys,
  PAYOUT_STATUS__PENDING,
  PAYOUT_STATUS__APPROVED,
  PAYOUT_STATUS__CANCELED,
  PAYOUT_STATUS__CANCELED_BY_USER,
  payoutStatuses,
  payoutStatusLangKeys,
  payoutCancelReasons,
  payoutCancelReasonLangKeys
};

export const API_PAYOUT_REQUEST_WRONG_METHOD_ERROR = 'PAYOUT_REQUEST_WRONG_METHOD';
export const API_PAYOUT_REQUEST_UNAVAILABLE_ERROR = 'PAYOUT_REQUEST_UNAVAILABLE';
export const API_PAYOUT_REQUEST_METHOD_FORBIDDEN_ERROR = 'PAYOUT_REQUEST_METHOD_FORBIDDEN';
export const API_PAYOUT_REQUEST_NO_DETAILS_ERROR = 'PAYOUT_REQUEST_NO_DETAILS';
export const API_PAYOUT_REQUEST_NO_FISCAL_NUMBER_ERROR = 'PAYOUT_REQUEST_NO_FISCAL_NUMBER';
export const API_PAYOUT_REQUEST_CREDIT_CARD_NOT_ACTIVE_ERROR = 'PAYOUT_REQUEST_CREDIT_CARD_NOT_ACTIVE';
export const API_PAYOUT_REQUEST_BLOCK_PERIOD_NOT_EXPIRED_ERROR = 'PAYOUT_REQUEST_BLOCK_PERIOD_NOT_EXPIRED';
export const API_PAYOUT_REQUEST_NO_ENOUGH_REVENUE_ERROR = 'PAYOUT_REQUEST_NO_ENOUGH_REVENUE';
export const API_W9_FORM_NOT_APPROVED_ERROR = 'W9_FORM_NOT_APPROVED';
